import axios from "axios";
import QRCode from "qrcode";
import { config } from "../utils/Constants";
import useGenerateToken from "../authentication/GenerateToken";
import useErrorHandler from "../components/ErrorHandler";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setWebSocket } from "../features/webSocketSlice";
import { useDispatch } from "react-redux";
import { settingData } from "../features/BSLAccountSlice";

const useLoginAPI = () => {
  const { ErrorHandler } = useErrorHandler();
  const URL = config.url;
  const { generateToken } = useGenerateToken();
  const [isLoading, setIsLoading] = useState(true);
  const [mobileLoginData, setMobileLoginData] = useState([]);
  const [deepLinkData, setDeepLinkData] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const PortalOnBoard = async (setQrTimeOut, setQrUrl, code) => {
    try {
      setQrTimeOut(false);
      setIsLoading(true);
      const url = URL + "/v1/Auth/PortalOnBoard";
      const res = await axios.post(url, {
        Code: code,
      });

      sessionStorage.setItem("SessionID", res.data.Payload.SessionID);
      setDeepLinkData(res.data.Payload.deeplink || null);          
      const qr = await QRCode.toDataURL(res.data.Payload.QR);
      setIsLoading(false);
      setQrUrl(qr);
    } catch (e) {
      ErrorHandler(e);
      setIsLoading(false);
      setQrTimeOut(true);
    }
  };

  const checkQrAxios = async () => {
    const body = {
      SessionID: sessionStorage.getItem("SessionID"),
      Code: sessionStorage.getItem("RegCodUrl") || "",
    };
    const res = await axios.post(`${URL}/v1/Auth/CheckQrStatus`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = res.data.Payload;
    const EntityMobile =
      res.data.Payload.SwitchLegalEntities?.[0]?.MobileNo || "";

    if (result) {
      sessionStorage.setItem("Features", JSON.stringify(result.Categories));
      sessionStorage.setItem("Tabs", JSON.stringify(result.Tabs));
      sessionStorage.setItem("EntityType", result.EntityType);
      sessionStorage.setItem("EntityRole", result.Role);
      sessionStorage.setItem("EntityID", result.EntityID);
      sessionStorage.setItem("LegalEntityID", result.LegalEntityID);
      sessionStorage.setItem("EmployeeID", result.EmployeeID);
      sessionStorage.setItem("webKey", result.WebKey);
      sessionStorage.setItem("EmployeeEmail", result?.EmployeeEmail);
      sessionStorage.setItem("IsAdvanceAllowed", result?.IsAdvanceAllowed);

      if (result.SwitchLegalEntities?.length) {
        sessionStorage.setItem(
          "Entities",
          JSON.stringify(result.SwitchLegalEntities)
        );
        if (result.EntityType === "LEGALENTITY") {
          const legalEntity = result.SwitchLegalEntities.find(
            (entity) => entity.LegalEntityID === result.EntityID
          );
          sessionStorage.setItem("EntityName", legalEntity.LegalEntityName);
          sessionStorage.setItem("EntityURL", legalEntity.LegalEntityIconUrl);
          sessionStorage.setItem("UserName", legalEntity.UserName);
          sessionStorage.setItem("EntityAddress", legalEntity.EntityAddress);
          sessionStorage.setItem("EntityMobile", legalEntity.MobileNo);
          sessionStorage.setItem("UserIconUrl", legalEntity.UserIconUrl);
          sessionStorage.setItem("LegalEntityName", legalEntity?.LegalEntityName);
        }
      }

      if (result.SwitchMerchants?.length) {
        sessionStorage.setItem(
          "Merchants",
          JSON.stringify(result.SwitchMerchants)
        );
        if (result.EntityType === "MERCHANTEMPLOYEE") {
          const merchant = result.SwitchMerchants.find(
            (entity) => entity.MerchantID === result.EntityID
          );
          sessionStorage.setItem("EntityName", merchant.MerchantName);
          sessionStorage.setItem("EntityURL", merchant.MerchantIconUrl);
          sessionStorage.setItem("UserName", merchant.UserName);
          sessionStorage.setItem("EntityURLMer", merchant.MerchantIconUrl);
        }
      } else {
        sessionStorage.setItem("Merchants", null);
      }

      return res;
    }
  };

  const CheckQrStatus = async (timerStatus, setQrTimeOut) => {
    try {
      const res = await checkQrAxios();
      const status = res.data.Payload.SessionStatus;
      sessionStorage.setItem("BslStatus", res.data.Payload?.BslStatus);
      dispatch(
        settingData({ field: "checkqrstatus", value: res.data.Payload })
      );

      if (status.toUpperCase() === "ACTIVE") {
        clearInterval(timerStatus);
        setIsLoading(true);
        try {
          await generateToken(
            sessionStorage.getItem("SessionID"),
            timerStatus,
            res.data
          );
        } catch (e) {
          setIsLoading(false);
          clearInterval(timerStatus);
          setQrTimeOut(true);
          return;
        }
      }
      if (status.toUpperCase() === "SELF_REGISTERING") {
        clearInterval(timerStatus);
        setIsLoading(false);
        setQrTimeOut(true);

        navigate("/enrollment/1");
      }
      return {
        status: res.status,
        sessionStatus: status,
      };
    } catch (e) {
      setIsLoading(false);
      clearInterval(timerStatus);
      throw e;
    }
  };

  const MobileLogin = async (
    userAccountId,
    timeStamp,
    reference,
    action,
    secureHash
  ) => {
    try {
      await axios
        .post(`${URL}/V1/AuthMobile/MobileLogIn`, {
          UserAccountId: userAccountId,
          TimeStamp: timeStamp,
          Reference: reference,
          ActionTypeId: action,
          SecureHash: secureHash,
        })
        .then((res) => {
          const result = res.data.Payload;

          if (result) {
            sessionStorage.setItem("TokenMobile", result.Token);
            sessionStorage.setItem("SessionMobile", result.SessionID);
            sessionStorage.setItem(
              "IsMobileLogIn",
              result.CheckQRStatusResponse.IsMobileLogIn
            );
          }
          setMobileLoginData(res.data);
          dispatch(setWebSocket(result.WebSokcetToken));
        });
    } catch (error) {
      console.error(error);
    }
  };

  return {
    isLoading,
    PortalOnBoard,
    CheckQrStatus,
    checkQrAxios,
    MobileLogin,
    mobileLoginData,
    deepLinkData
  };
};

export default useLoginAPI;
